module.exports = __webpack_public_path__ + "img/tg.b89ccd80.png";